import React from 'react';

import Image from '../../library/image/image';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import CirclesRating, {
  FilledCircleColor
} from '../circles-rating/circles-rating';
import SnowyRoad from '../snowy-road/snowy-road';
import StoppingDistanceChart from '../stopping-distance-chart/stopping-distance-chart';

import { useContainerQuery } from '../../shared/hooks/hooks';

import { Maybe } from '../../shared/types/graphql-types';

import styles from './snow-stopping-distance-info.scss';

interface SnowStoppingDistanceInfoProps {
  stoppingDistanceFeet: number;
  stoppingDistanceRating?: number;
  stoppingDistanceTitle?: Maybe<string>;
  stoppingDistanceTooltipText?: Maybe<string>;
}

function SnowStoppingDistanceInfo(props: SnowStoppingDistanceInfoProps) {
  const {
    stoppingDistanceFeet,
    stoppingDistanceRating,
    stoppingDistanceTitle,
    stoppingDistanceTooltipText
  } = props;

  const { isMinLg } = useContainerQuery();
  const showStoppingDistanceRating = Number(stoppingDistanceRating) > 0;

  return (
    <div>
      <div className={styles['title']}>
        <div>
          <Image
            alt="Stopping Distance Icon"
            className={styles['icon']}
            height="20"
            src="https://discounttire.scene7.com/is/content/discounttire/treadwell/treadwell_ic_stopping_distance.svg"
            width="20"
          />
          <Typography weight="bold">
            {stoppingDistanceTitle || 'Snow Stopping Distance'}
          </Typography>
          {stoppingDistanceTooltipText && (
            <Tooltip
              className={styles['tooltip']}
              content={stoppingDistanceTooltipText}
            />
          )}
        </div>
        {showStoppingDistanceRating && (
          <div className={styles['circles-rating-container']}>
            <CirclesRating
              filledCircleColor={FilledCircleColor.GREY}
              rating={Number(stoppingDistanceRating)}
            />
            {stoppingDistanceRating!.toFixed(1)}
          </div>
        )}
      </div>
      <div className={styles['chart-row-stopping-distance']}>
        <StoppingDistanceChart
          bottomOffset={isMinLg ? 8 : 0}
          className={styles['stopping-distance-chart']}
          renderTicks={(_, scaleMax, scaleMin) => (
            <>
              <SnowyRoad />
              <span className={styles['tick']} style={{ right: '2px' }}>
                {scaleMax}
              </span>
              <span className={styles['tick']} style={{ left: '2px' }}>
                {scaleMin}
              </span>
            </>
          )}
          scaleMax={120}
          scaleMin={0}
          value={stoppingDistanceFeet}
        />
      </div>
    </div>
  );
}

export default SnowStoppingDistanceInfo;
